export default {
  TableHeadMember: [
    [
      {
        displayName: 'report.winloseSimple.datatable.number',
        attr: {
          rowspan: 2,
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.username',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'point.mysteries_book',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'point.continuous_login',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'point.drop_points',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'point.level_up',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'point.rank_up',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'point.rolling',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'point.total',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
    ],
  ],
  TableHeadLog: [
    [
      {
        displayName: 'report.winloseSimple.datatable.number',
        attr: {
          rowspan: 2,
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.info',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.activity',
        attr: {
          rowspan: 2,
          class: 'text-left',
        },
      },
      {
        displayName: 'report.winloseSimple.datatable.amount',
        attr: {
          rowspan: 2,
          class: 'text-right',
        },
      },
    ],
  ],
};
